//
// AccessibilityFocusChangeEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../events/PortableEvent";
import "./AccessibilityElement";

var AccessibilityFocusChangeEvent = createModule("commons_AccessibilityFocusChangeEvent", [125,10003], ClosetObject, [
    {
        ACCESSIBILITY_ELEMENTS_INVALIDATED: 20009,
        ACCESSIBILITY_DRILL_DOWN: 20005,
        ACCESSIBILITY_FOCUS_CHANGE: 20000,
        ACCESSIBILITY_COLLAPSE: 20004,
        ACCESSIBILITY_DATA_CELL: 20007,
        ACCESSIBILITY_FOCUS_GAINED: 20002,
        ACCESSIBILITY_SORT: 20006,
        ACCESSIBILITY_EXPAND: 20003,
        ACCESSIBILITY_ELEMENT_SELECTED: 20008,
        ACCESSIBILITY_FOCUS_LOST: 20001,
    },
    ,
    ,
    ,
    {
        getAccessibilityElement: [1],
    },
    ,
    ,
]);
export default AccessibilityFocusChangeEvent;
